var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounSign2162275(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "150px",
    width: "150px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22,10H10a1,1,0,0,0,0,2H22a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.71,10.29a1.032,1.032,0,0,0-.33-.21,1,1,0,0,0-1.09.21,1.032,1.032,0,0,0-.21.33,1,1,0,1,0,1.84,0A1.155,1.155,0,0,0,26.71,10.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,40H10a1,1,0,0,0,0,2H22a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.71,40.29a1.047,1.047,0,0,0-1.42,0,1.155,1.155,0,0,0-.21.33.99.99,0,0,0,.21,1.09,1.155,1.155,0,0,0,.33.21.99.99,0,0,0,1.3-1.3A1.155,1.155,0,0,0,26.71,40.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.707,21.293A1,1,0,0,0,56,21H35V3a1,1,0,0,0-1-1H30a1,1,0,0,0-1,1V6H8a1,1,0,0,0-.707.293l-5,5a1,1,0,0,0,0,1.414l5,5A1,1,0,0,0,8,18H29V36H8a1,1,0,0,0-.707.293l-5,5a1,1,0,0,0,0,1.414l5,5A1,1,0,0,0,8,48H29v6H28a5.006,5.006,0,0,0-5,5v1H19a1,1,0,0,0,0,2H45a1,1,0,0,0,0-2H41V59a5.006,5.006,0,0,0-5-5H35V33H56a1,1,0,0,0,.707-.293l5-5a1,1,0,0,0,0-1.414ZM8.414,16l-4-4,4-4H29v8Zm0,30-4-4,4-4H29v8ZM39,59v1H25V59a3,3,0,0,1,3-3h8A3,3,0,0,1,39,59Zm-8-5V4h2V54ZM55.586,31H35V23H55.586l4,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,25H42a1,1,0,0,0,0,2H54a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.38,25.08a.968.968,0,0,0-1.3.54A1,1,0,1,0,39,26a1.05,1.05,0,0,0-.29-.71A.933.933,0,0,0,38.38,25.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,62a1,1,0,0,0,0-2H49a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,62a1,1,0,0,0,0-2H11a1,1,0,0,0,0,2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounSign2162275);
export default __webpack_public_path__ + "static/media/noun_Sign_2162275.4f35e845.svg";
export { ForwardRef as ReactComponent };